import React from 'react';

const UserProfile: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">User Profile</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p>User profile page coming soon...</p>
      </div>
    </div>
  );
};

export default UserProfile;
